import { ChangeDetectionStrategy, Component, inject, Inject } from '@angular/core';
import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import {
    IInputDataConfirmCloseDialog,
    IOutputDataConfirmCloseDialog,
} from '@components/dialog/interfaces/dialog.interface';
import { LANG_DICTIONARY_TOKEN } from '@constants/diConstant';
import { IMainLang } from '@interfaces/languages/main-lang';

@Component({
    selector: 'app-confirm-close-dialog',
    templateUrl: './confirm-close-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmCloseDialogComponent {
    readonly #dialogRef: MatDialogRef<ConfirmCloseDialogComponent, IOutputDataConfirmCloseDialog> =
        inject(MatDialogRef);

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IInputDataConfirmCloseDialog,
        @Inject(LANG_DICTIONARY_TOKEN) public readonly dictionary: IMainLang = null,
    ) {}

    public close(data: IOutputDataConfirmCloseDialog): void {
        this.#dialogRef.close(data);
    }
}
